import { useEffect, useRef, useState } from "react";

const AutoScroll = ({ children }) => {
  const containerRef = useRef(null);
  const animationRef = useRef(null);
  const animateRef = useRef(null); // Store animate function here
  const scrollSpeed = 50; // Pixels per second
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 768px)");
    setIsMobile(mediaQuery.matches);

    const handler = (e) => setIsMobile(e.matches);
    mediaQuery.addListener(handler);
    return () => mediaQuery.removeListener(handler);
  }, []);

  useEffect(() => {
    if (isMobile) return; // Disable auto-scroll on mobile

    const container = containerRef.current;
    let lastTime = null;

    animateRef.current = (timestamp) => {
      if (!lastTime) lastTime = timestamp;
      const deltaTime = timestamp - lastTime;

      if (
        container.scrollLeft >=
        container.scrollWidth / 2 - container.clientWidth
      ) {
        container.scrollLeft = 0;
      } else {
        container.scrollLeft += (scrollSpeed * deltaTime) / 800;
      }

      lastTime = timestamp;
      animationRef.current = requestAnimationFrame(animateRef.current);
    };

    animationRef.current = requestAnimationFrame(animateRef.current);

    return () => cancelAnimationFrame(animationRef.current);
  }, [isMobile]);

  return (
    <div ref={containerRef} className="auto-scroll-container">
      {children}
    </div>
  );
};

export default AutoScroll;
